module.exports = __webpack_public_path__ + "static/media/6COPUOS2.e5e73b81.jpg";